/**
 * @copyright Valor Software
 * @copyright Angular ng-bootstrap team
 */
export class ContentRef {
    constructor(nodes, viewRef, componentRef) {
        this.nodes = nodes;
        this.viewRef = viewRef;
        this.componentRef = componentRef;
    }
}
//# sourceMappingURL=content-ref.class.js.map